module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAAJ1JREFUaAXt0kEKgCAQheEZ6Rh1oM4ReIWW0bIrBJ2jC3WODHMjLmaRiwr+QFCejc6HInwIIIAAAggggAACCCCAAAIIIIDAGwL69NBx3vog5xr/V3F+mYY9r1Wb57WseWOFVhYvHyS0ac/dSJfvr83zWtbcWeEfsscNxGejokcazpfN1uZlPdYIIIAAAggggAACCCCAAAIIIIDAtwQuaDEwFjdJ3nQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-check.png
// module id = u8wZ
// module chunks = 1